module.exports = __webpack_public_path__ + "img/logo.a76bd607.png";